<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        text
        v-on="on"
      >
        {{ text }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">
        Resend Confirmation email
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="email"
          v-validate="'required|email'"
          label="e-mail"
          :error-messages="errors.collect('email')"
          data-vv-name="email"
          required
          @keyup.enter="send"
        />
      </v-card-text>
      <v-card-text>Enter your email address, click send and follow the email instructions.</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          class="ma-2"
          depressed
          @click="send"
        >
          Send
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import AccountService from './../Dashboard/Views/Pages/services/AccountService'
  export default {
    props: {
      text: {
        type: String,
        default: "Didn't receive activation email yet ?",
      },
    },
    data () {
      return {
        dialog: false,
        email: '',
      }
    },
    methods: {
      send () {
        let self = this
        self.$validator.validateAll().then((result) => {
          if (result) {
            AccountService.emailNotReceived(self.email, self).then(() => {
              self.dialog = false
            })
          }
        })
      },
    },
  }
</script>
